import { getAnonId } from "../storage/anonId";

// Mapping de eventos internos a eventos GA4
const EVENT_MAPPING = {
  // Programas
  'programs_index_view': { ga_event: 'page_view', category: 'programs' },
  'program_view': { ga_event: 'view_item', category: 'programs' },
  'program_shared': { ga_event: 'share', category: 'programs' },
  
  // Audio
  'unit_view': { ga_event: 'view_item', category: 'audio' },
  'audio_start': { ga_event: 'audio_start', category: 'engagement', conversion: false },
  'audio_25': { ga_event: 'audio_progress_25', category: 'engagement' },
  'audio_50': { ga_event: 'audio_progress_50', category: 'engagement' },
  'audio_75': { ga_event: 'audio_progress_75', category: 'engagement' },
  'audio_complete': { ga_event: 'audio_complete', category: 'engagement', conversion: true },
  
  // Completación
  'unit_complete': { ga_event: 'unit_complete', category: 'achievement', conversion: true },
  'test_start': { ga_event: 'test_start', category: 'assessment' },
  'test_complete': { ga_event: 'test_complete', category: 'assessment', conversion: true },
  'program_completed': { ga_event: 'program_complete', category: 'achievement', conversion: true }
};

export function track(event, payload = {}) {
  const anonId = getAnonId();
  const timestamp = Date.now();
  
  // Log a consola (desarrollo)
  if (import.meta.env.MODE !== 'production') {
    console.log("[TRACK]", { event, anonId, ...payload, ts: timestamp });
  }
  
  // Enviar a GA4 si está disponible
  if (typeof window !== 'undefined' && window.gtag) {
    const eventConfig = EVENT_MAPPING[event] || { ga_event: event, category: 'custom' };
    
    // Preparar parámetros para GA4
    const gaParams = {
      event_category: eventConfig.category,
      event_label: payload.label || event,
      user_id: anonId,
      ...payload
    };
    
    // Limpiar parámetros undefined
    Object.keys(gaParams).forEach(key => {
      if (gaParams[key] === undefined) delete gaParams[key];
    });
    
    // Enviar evento
    window.gtag('event', eventConfig.ga_event, gaParams);
    
    // Si es evento de conversión, marcarlo
    if (eventConfig.conversion) {
      window.gtag('event', 'conversion', {
        send_to: import.meta.env.VITE_GA_MEASUREMENT_ID || 'G-694BHPRXGS',
        event_category: eventConfig.category,
        value: 1
      });
    }
  }
}
